import { createIcon } from '@chakra-ui/react';

export const Ticket = createIcon({
  displayName: 'Ticket',
  viewBox: '0 0 24 24',
  path: (
    <g id="Icon" transform="translate(-57 -709)">
      <rect
        id="Icon_Space"
        data-name="Icon Space"
        transform="translate(57 709)"
        fill="none"
      />
      <g
        id="Ticket_-_L"
        data-name="Ticket - L"
        transform="translate(57 713.397)"
      >
        <path
          id="Ticket_-_L-2"
          data-name="Ticket - L"
          d="M5.8,23.158a.757.757,0,1,0,.757.757A.757.757,0,0,0,5.8,23.158Zm0-5.617a.757.757,0,1,0,.757.757A.757.757,0,0,0,5.8,17.54Zm0-2.811a.751.751,0,1,1,0,.011ZM17.9,26.033H1.635V22.515a2.871,2.871,0,0,0,0-5.629v-3.6H17.84a.567.567,0,1,0,0-1.135H1.067a.564.564,0,0,0-.567.571v4.668a.567.567,0,0,0,.567.571,1.74,1.74,0,1,1,0,3.48A.564.564,0,0,0,.5,22V26.6a.564.564,0,0,0,.567.564H17.89a.567.567,0,1,0,0-1.135ZM5.8,20.359a.314.314,0,1,0,0-.008Zm13.263-5.617a.757.757,0,1,0,.757.757A.757.757,0,0,0,19.058,14.741Zm4.589,3.231h.095a.594.594,0,0,0,.416-.155.571.571,0,0,0,.174-.427V12.721a.564.564,0,0,0-.567-.564H20.537a.567.567,0,1,0,0,1.135h2.648v3.582a2.871,2.871,0,0,0,0,5.674v3.5H20.447a.567.567,0,1,0,0,1.135h3.318a.564.564,0,0,0,.564-.564V22a.556.556,0,0,0-.185-.409.567.567,0,0,0-.378-.159H23.67a1.74,1.74,0,0,1,0-3.48Zm-4.589-.431a.757.757,0,1,0,.757.757A.757.757,0,0,0,19.058,17.54Zm0,2.811a.757.757,0,1,0,.757.757.757.757,0,0,0-.757-.757Zm0,2.807a.757.757,0,1,0,.757.757A.757.757,0,0,0,19.058,23.158Z"
          transform="translate(-0.5 -12.15)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
